import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  RedoOutlined,
} from '@/shared/ui/icons'
import { forwardRef } from 'react'
import UiButton, { type ButtonCustomProps } from './index'

/**
 * Nút Thêm mới: Mặc định tone primary, variant solid, icon PlusOutlined bên trái.
 */
export const UiCreateButton = forwardRef<HTMLButtonElement, ButtonCustomProps>(
  ({ children = 'Thêm mới', icon, tone = 'primary', ...props }, ref) => {
    return (
      <UiButton ref={ref} tone={tone} icon={icon ?? <PlusOutlined />} {...props}>
        {children}
      </UiButton>
    )
  }
)
UiCreateButton.displayName = 'UiCreateButton'

/**
 * Nút Ghi lại / Lưu: Mặc định tone primary, variant solid, htmlType="submit", icon CheckOutlined bên trái.
 */
export const UiSaveButton = forwardRef<HTMLButtonElement, ButtonCustomProps>(
  ({ children = 'Ghi lại', icon, tone = 'primary', htmlType = 'submit', ...props }, ref) => {
    return (
      <UiButton
        ref={ref}
        tone={tone}
        htmlType={htmlType}
        icon={icon ?? <CheckOutlined />}
        {...props}
      >
        {children}
      </UiButton>
    )
  }
)
UiSaveButton.displayName = 'UiSaveButton'

/**
 * Nút Sửa: Mặc định tone primary, variant outlined hoặc solid, icon EditOutlined bên trái.
 */
export const UiEditButton = forwardRef<HTMLButtonElement, ButtonCustomProps>(
  ({ children = 'Sửa', icon, tone = 'primary', variant = 'outlined', ...props }, ref) => {
    return (
      <UiButton ref={ref} tone={tone} variant={variant} icon={icon ?? <EditOutlined />} {...props}>
        {children}
      </UiButton>
    )
  }
)
UiEditButton.displayName = 'UiEditButton'

/**
 * Nút Xóa / Thao tác nguy hiểm: Mặc định tone danger (màu đỏ), icon DeleteOutlined bên trái.
 */
export const UiDeleteButton = forwardRef<HTMLButtonElement, ButtonCustomProps>(
  ({ children = 'Xóa', icon, tone = 'danger', danger = true, ...props }, ref) => {
    return (
      <UiButton ref={ref} tone={tone} danger={danger} icon={icon ?? <DeleteOutlined />} {...props}>
        {children}
      </UiButton>
    )
  }
)
UiDeleteButton.displayName = 'UiDeleteButton'

/**
 * Nút Hủy / Đóng: Mặc định tone neutral, variant outlined, icon CloseOutlined bên trái.
 */
export const UiCancelButton = forwardRef<HTMLButtonElement, ButtonCustomProps>(
  ({ children = 'Hủy', icon, tone = 'neutral', variant = 'outlined', ...props }, ref) => {
    return (
      <UiButton ref={ref} tone={tone} variant={variant} icon={icon ?? <CloseOutlined />} {...props}>
        {children}
      </UiButton>
    )
  }
)
UiCancelButton.displayName = 'UiCancelButton'

/**
 * Nút Làm mới: Mặc định tone neutral, variant outlined, icon RedoOutlined bên trái.
 */
export const UiRefreshButton = forwardRef<HTMLButtonElement, ButtonCustomProps>(
  ({ children = 'Làm mới', icon, tone = 'neutral', variant = 'outlined', ...props }, ref) => {
    return (
      <UiButton ref={ref} tone={tone} variant={variant} icon={icon ?? <RedoOutlined />} {...props}>
        {children}
      </UiButton>
    )
  }
)
UiRefreshButton.displayName = 'UiRefreshButton'
